import React, { createContext, useReducer, useEffect } from 'react';
import Cookies from 'js-cookie';

export const AuthContext = createContext();

const cookieConfig = {
  secure: process.env.REACT_APP_ENVIRONMENT === 'production',
  domain: process.env.REACT_APP_ENVIRONMENT === 'production' ? '.sportaloka.com' : 'localhost',
  path: '/'
};

const initialState = {
  access_token: '',
  refresh_token: '',
  session_id: '',
  user_profile: '',
  init_loading: true
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_INIT':
      return {
        ...state,
        init_loading: action.payload
      };
    case 'SET_FROM_COOKIE':
      return {
        ...state,
        access_token: action.payload.access_token,
        refresh_token: action.payload.refresh_token,
        session_id: action.payload.session_id,
        user_profile: action.payload.user_profile
      };
    default:
      return {
        ...state
      };
  }
};

export const AuthProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    async function fetchCookie() {
      const access_token = Cookies.get('access_token');
      const refresh_token = Cookies.get('refresh_token');
      const session_id = Cookies.get('session_id');
      const user_profile = Cookies.get('user_profile');
      const profile = user_profile ? JSON.parse(user_profile) : null;
      dispatch({
        type: 'SET_FROM_COOKIE',
        payload: {
          access_token: access_token ? access_token : '',
          refresh_token: refresh_token ? refresh_token : '',
          session_id: session_id ? session_id : '',
          user_profile: profile
        }
      });
      // TODO : TENANT STATUS HARUS SUDAH AKTIF
      if (!access_token || !profile || !profile.type.includes('TENANT')) {
        window.location.replace(`${process.env.REACT_APP_PUBLIC_WEB_URL}/auth/signin`);
      } else {
        dispatch({
          type: 'SET_INIT',
          payload: false
        });
      }
    }
    fetchCookie();
  }, []);

  useEffect(() => {
    if (state.access_token) {
      Cookies.set('access_token', state.access_token, cookieConfig);
    }

    if (state.refresh_token) {
      Cookies.set('refresh_token', state.refresh_token, cookieConfig);
    }

    if (state.session_id) {
      Cookies.set('session_id', state.session_id, cookieConfig);
    }

    if (state.user_profile) {
      Cookies.set('user_profile', JSON.stringify(state.user_profile), cookieConfig);
    }
  }, [state]);

  return <AuthContext.Provider value={[state, dispatch]}>{props.children}</AuthContext.Provider>;
};
